import React, { createContext, Dispatch, useContext, useReducer } from "react";
import { BlogsFromAPI } from "../../../interfaces/blog/BlogsFromAPI";

type BlogContextProps = {
  state: BlogContextState;
  dispatch: Dispatch<BlogContextState>;
};

type BlogContextState = {
  blogs?: BlogsFromAPI;
  isLoading?: boolean;
  isLoadingMore?: boolean;
  page?: number;
  hasMoreBlogs?: boolean;
};

const BlogContext = createContext<BlogContextProps | undefined>(undefined);

const blogProviderReducer = (
  initialState: BlogContextState,
  newState: BlogContextState,
): BlogContextState => {
  return {
    blogs: newState.blogs ?? initialState.blogs,
    isLoading: newState.isLoading ?? initialState.isLoading,
    page: newState.page ?? initialState.page,
    isLoadingMore: newState.isLoadingMore ?? initialState.isLoadingMore,
    hasMoreBlogs: newState.hasMoreBlogs ?? initialState.hasMoreBlogs,
  };
};

const initialState: BlogContextState = {
  blogs: { count: 0, rows: [] },
  isLoading: true,
  page: 0,
  isLoadingMore: false,
  hasMoreBlogs: true,
};

export const BlogPageProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [state, dispatch] = useReducer(blogProviderReducer, initialState);

  return (
    <BlogContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </BlogContext.Provider>
  );
};

export const useBlogContext = () => {
  const context = useContext(BlogContext);

  if (!context) {
    throw new Error("useBlogContext must be used within a FirebaseProvider");
  }

  return context;
};
